import styled from "styled-components";
import { Title2 } from "../../styles/typography";

export const EditorPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: rgb(${(props) => props.theme.colors.white});
`;

export const EditorHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 2px solid rgb(${(props) => props.theme.colors.neutral100});
  background: rgb(${(props) => props.theme.colors.white});
  position: sticky;
  top: 0;
  z-index: 20;
`;

export const BackButton = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgb(${(props) => props.theme.colors.neutral200});
  flex-shrink: 0;

  &:hover {
    border-color: rgb(${(props) => props.theme.colors.neutral200});
    color: rgb(${(props) => props.theme.colors.neutral400});
  }
`;

export const TitleInput = styled.input`
  flex: 1;
  font-family: "Lora", serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  color: rgb(${(props) => props.theme.colors.neutral600});
  border: none;
  outline: none;
  background: transparent;
  min-width: 0;

  &::placeholder {
    color: rgb(${(props) => props.theme.colors.neutral150});
  }
`;

export const TitleError = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: rgb(${(props) => props.theme.colors.error400});
  margin-top: 2px;
  display: block;
  padding: 0 16px;
`;

export const EditorBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 1000px;
  width: 100%;
  margin: auto;
  position: relative;
`;

export const SubmitButton = styled.button`
  flex-shrink: 0;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background: rgb(${(props) => props.theme.colors.neutral600});
  color: rgb(${(props) => props.theme.colors.white});
  transition: opacity 0.15s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 600px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${Title2} {
    color: rgb(${(props) => props.theme.colors.neutral600});
    padding: 16px;
  }
  border-bottom: 2px solid rgb(${(props) => props.theme.colors.neutral600});
`;

export const Content = styled.div``;
